export default __webpack_public_path__ + "static/media/6199.496d8608.svg";